import React, { useEffect, useState, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../services/api.js';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';

export default function ValidarCorreoSolicitud() {
  const { token } = useParams();
  const [estado, setEstado] = useState('cargando');
  const [mensaje, setMensaje] = useState('');
  const [nroSeguimiento, setNroSeguimiento] = useState(null);
  
  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    
    const validar = async () => {
      try {
        const res = await api.get(`/solicitudes/validar-correo/${token}`);
        setEstado('exito');
        setMensaje(res.data.message || 'Tu solicitud ha sido validada e ingresada correctamente.');
        if (res.data.numero_seguimiento) {
          setNroSeguimiento(res.data.numero_seguimiento);
        }
      } catch (err) {
        setEstado('error');
        setMensaje(err.response?.data?.error || err.response?.data?.message || 'El enlace es inválido, ha expirado o ya fue utilizado.');
      }
    };

    validar();
  }, [token]);

  return (
    <div className="container animate-fade-in" style={{ padding: '4rem 1rem', maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
      <div className="glass-card" style={{ padding: '3rem 2rem' }}>
        
        {estado === 'cargando' && (
          <div>
            <Loader2 size={64} className="spinner" style={{ margin: '0 auto 1.5rem auto', color: 'var(--copper)' }} />
            <h2 style={{ color: 'var(--primary-dark)', marginBottom: '1rem' }}>Verificando enlace...</h2>
            <p className="text-muted">Por favor, espera unos segundos mientras comprobamos tu solicitud.</p>
          </div>
        )}

        {estado === 'exito' && (
          <div className="animate-scale-in">
            <CheckCircle size={72} style={{ margin: '0 auto 1.5rem auto', color: 'var(--success)' }} />
            <h2 style={{ color: 'var(--primary-dark)', marginBottom: '1rem' }}>¡Correo Validado!</h2>
            <p style={{ fontSize: '1.1rem', marginBottom: '1.5rem', color: 'var(--text-main)' }}>
              {mensaje}
            </p>
            
            {nroSeguimiento && (
              <div style={{ background: 'rgba(var(--copper-rgb), 0.1)', border: '1px solid var(--copper-light)', padding: '1.5rem', borderRadius: '12px', marginBottom: '2rem' }}>
                <p style={{ margin: '0 0 0.5rem 0', color: 'var(--copper)', fontWeight: 600 }}>Tu Número de Seguimiento es:</p>
                <div style={{ fontSize: '2rem', fontFamily: 'monospace', fontWeight: 'bold', color: 'var(--primary-dark)', letterSpacing: '2px' }}>
                  {nroSeguimiento}
                </div>
                <p style={{ margin: '0.5rem 0 0 0', fontSize: '0.85rem', color: 'var(--gray-500)' }}>Guarda este código para hacer seguimiento a tu solicitud.</p>
              </div>
            )}

            <Link to="/estadosolicitud" className="btn btn-primary btn-lg" style={{ display: 'inline-flex', padding: '1rem 3rem' }}>
              Ir al Seguimiento en Línea
            </Link>
          </div>
        )}

        {estado === 'error' && (
          <div className="animate-scale-in">
            <XCircle size={72} style={{ margin: '0 auto 1.5rem auto', color: 'var(--error)' }} />
            <h2 style={{ color: 'var(--error)', marginBottom: '1rem' }}>Error de Validación</h2>
            <p style={{ fontSize: '1.1rem', marginBottom: '2rem', color: 'var(--text-main)' }}>
              {mensaje}
            </p>
            <Link to="/solicitud" className="btn btn-secondary">
              Volver al Portal
            </Link>
          </div>
        )}

      </div>
    </div>
  );
}
